import src from "IMAGE";
export default { src, width: 1198, height: 493, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42jXIUQ6AIAwEUe5/WKXbWkBI10LiJO9niikIKOfofHtnuy8Of+hmR5k5t1jraDktAaCIskQEt7/hTlMlRFir8AMJw11dIYu1+wAAAABJRU5ErkJggg=="};
